module.exports = __webpack_public_path__ + "static/yellow-send-e8c5485ea45d110bd8f9ecdc6b9a2cdf.jpg";